import script from "./CreateDevice.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateDevice.vue?vue&type=script&setup=true&lang=js"

import "./CreateDevice.vue?vue&type=style&index=0&id=a32fce96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a32fce96"]])

export default __exports__